import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    pending: 'Pending',
    seeMore: 'See More',
  },
  fr: {
    pending: 'En attente',
    seeMore: 'Voir plus',
  },
});

export default locales;
